import Vue from "vue";
import Router from "vue-router";
import {SiteSettingMixin} from "./mixins/SiteSettingMixin";

Vue.use(Router);

export default new Router({
    mixins:[SiteSettingMixin],
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "dashboard",
                    name: "dashboard",
                    meta: {
                        keepAlive: false,
                        title: 'Dashboard',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/Dashboard.vue")
                },

                {
                    path: "chat",
                    name: "chat",
                    meta: {

                        title: 'Chat',
                        key: 'fullPath',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/chat/Chat.vue")
                },

                {
                    path: "results",
                    name: "teacher-results",
                    meta: {
                        keepAlive: false,
                        title: 'Results',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/results/Index.vue"),
                },
                {
                    path: "courses",
                    name: "teacher-courses",
                    meta: {
                        keepAlive: false,
                        title: 'My courses',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/courses/Courses.vue"),
                },
                {
                    path: "students",
                    name: "students",
                    meta: {
                        keepAlive: false,
                        title: 'Students',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/students/Students.vue"),
                },
                {
                    path: "attendance-summary",
                    name: "attendance-summary",
                    meta: {
                        keepAlive: false,
                        title: 'Attendance summary',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/academic-class/summary/attendance/AttendanceReport.vue"),
                },
                {
                    path: "lesson/planner",
                    name: "teacher-lesson-plan",
                    component: () => import("@/view/pages/lesson-planner/Index.vue"),
                },
                {
                    path: "lesson/planner/:lesson_plan_id/summary",
                    name: "teacher-lesson-plan-summary",
                    meta: {
                        keepAlive: false,
                        title: 'Lesson summary',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/lesson-planner/Summary.vue"),
                },
                {
                    path: ":lesson_plan_id/courses-summary",
                    name: "courses-summary",
                    meta: {

                        title: 'Courses summary',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/courses/Summary.vue")

                },
                {
                    path: "/:lesson_plan_id/courses-progress",
                    name: "courses-progress-summary",
                    meta: {
                        keepAlive: false,
                        title: 'Courses summary',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/lesson-planner/progress/summary.vue")

                },
                {
                    path: "assignments",
                    name: "assignment",
                    meta: {
                        keepAlive: false,
                        title: 'Assignments',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/assignment/Index.vue")

                },
                {
                    path: "notification",
                    name: "notification",
                    component: () => import("@/view/pages/notifications/Notification.vue")

                },
                {
                    path: "leave",
                    name: "leave",
                    meta: {

                        title: 'Notification-topic', // tab title
                        tabClass: 'custom-tab', // custom class, optional
                        key: 'path', // tab cache rule, optional
                        closable: true,
                        keepAlive: false// is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/leave/leave/Index.vue")
                },
                {
                    path: "time-table",
                    name: "time-table",
                    meta: {
                        keepAlive: false,
                        title: 'Assignments',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/time-table/TimeTable.vue")

                },
                {
                    path: "assignments/questions",
                    name: "assignment-questions",
                    meta: {
                        keepAlive: false,
                        title: 'Assignment questions',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/assignment/question/Index.vue")

                },
                {
                    path: "assignments/:assignment_id/submission",
                    name: "assignment-submission",
                    meta: {
                        keepAlive: false,
                        title: 'Assignment submissions',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/assignment/submission/Index.vue")
                },
                {
                    path: "assignments/:assignment_id/submission/:student_id",
                    name: "assignment-submission-detail",
                    meta: {
                        keepAlive: false,
                        title: 'Assignment submission detail',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/assignment/submission/SumissionDetail.vue")
                },
                {
                    path: "assignments/:assignment_id",
                    name: "assignment-edit",
                    meta: {
                        keepAlive: false,
                        title: 'Edit assignment',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/assignment/NewAssignment.vue")
                },
                {
                    path: "assignments/create",
                    name: "assignment-create",
                    meta: {
                        keepAlive: false,
                        title: 'Create assignment',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/assignment/NewAssignment.vue")
                },
                {
                    path: "assignments/:assignment_id/summary",
                    name: "assignment-summary",
                    meta: {
                        keepAlive: false,
                        title: 'Assignment summary',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/assignment/AssignmentDetail.vue")

                },
                {
                    path: "class",
                    name: "teacher-class",
                    meta: {
                        keepAlive: false,
                        title: 'Classroom',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/academic-class/Index.vue"),
                },
                {
                    path: "/:classId/summary",
                    name: "academic-class-summary",
                    meta: {
                        keepAlive: false,
                        title: 'Academic class summary',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/academic-class/ClassroomSummary.vue")

                },
                {
                    path: "library-resource",
                    name: "library-resource",
                    meta: {
                        keepAlive: false,
                        title: 'Library resource',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/library-resource/Index.vue"),
                },
                {
                    path: "results",
                    name: "results",
                    meta: {
                        keepAlive: false,
                        title: 'Results',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/results/Base.vue"),
                    children: [
                        {
                            path: "/",
                            name: "results-list",
                            meta: {
                                keepAlive: false,
                                title: 'Results',
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/Index.vue"),
                        },
                        {
                            path: "results/:slug/courses",
                            name: "results-view-all-courses",
                            meta: {
                                keepAlive: false,
                                title: 'Courses',
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/courses/Index.vue")
                        },
                        {
                            path: "results/exam/:slug/course/:courseId/students",
                            name: "results-view-all-courses-students",
                            meta: {
                                keepAlive: false,
                                title: 'Exam students',
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/courses/Students.vue")
                        },
                        {
                            path: "results/exam/:slug/course/:courseId/assessments",
                            name: "results-view-courses-assessments",
                            meta: {
                                keepAlive: false,
                                title: 'Student assessment',
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/courses/courseAssessment.vue")
                        },
                        {
                            path: "results/exam/:slug/course/:courseId/assessment/:assessmentId/students",
                            name: "results-view-courses-assessments-student",
                            meta: {
                                keepAlive: false,
                                title: 'Student Results',
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/courses/StudentsAssessment.vue")
                        },
                        {
                            path: "results/exam/assessment/:slug/course/:courseId/students",
                            name: "results-view-assessment-courses-students",
                            meta: {
                                keepAlive: false,
                                title: 'Result Assessment',
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/courses/StudentsAssessment.vue")
                        },
                        {
                            path: "results/:examId/students",
                            name: "results-view-all-courses-summary-students",
                            meta: {
                                keepAlive: false,
                                title: 'Result summary',
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/courses/ViewAllStudent.vue")
                        },
                        {
                            path: "exam-summary/:exam_id",
                            name: "exam-summary",
                            meta: {

                                title: 'Exam summary', // tab title
                                tabClass: 'custom-tab', // custom class, optional
                                key: 'path', // tab cache rule, optional
                                closable: true // is tab closable, defaults to `true`
                            },
                            component: () => import("@/view/pages/results/ExamSummary.vue")

                        },

                    ]
                },


                {
                    path: "attendance/:classId",
                    name: "class-attendance",
                    meta: {
                        keepAlive: false,
                        title: 'Class attendance',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/attendance/Attendance.vue")

                },
                {
                    path: "/unauthorized",
                    name: "unauthorized",
                    component: () => import("@/view/pages/error/unauthorized.vue")
                },
                {
                    path: "user-profile",
                    name: "profile",
                    meta: {
                        keepAlive: false,
                        title: 'Profile',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/profile/Index.vue")

                },
                {
                    path: "quiz",
                    name: "quiz",
                    meta: {
                        keepAlive: false,
                        title: 'Quiz',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/quiz/Index.vue")
                },
                {
                    path: "quiz/:id/result",
                    name: "quiz-result",
                    meta: {
                        keepAlive: false,
                        title: 'Quiz result',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/quiz/result/Index.vue")
                },
                {
                    path: "quiz/:quiz_id/update",
                    name: "quiz-update",
                    meta: {
                        keepAlive: false,
                        title: 'Quiz update',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/quiz/CreateOrUpdate.vue")
                },
                {
                    path: "question/bank/category",
                    name: "question-bank-category",
                    meta: {
                        keepAlive: false,
                        title: 'Question bank category',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/quiz/question-bank/category/Index.vue")
                },
                {
                    path: "question/bank",
                    name: "question-bank",
                    meta: {
                        keepAlive: false,
                        title: 'Question bank',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/quiz/question-bank/Index.vue")
                },
                {
                    path: "classroom/online",
                    name: "online-class-room",
                    meta: {
                        keepAlive: false,
                        title: 'Online classrooms',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/online-class-rooms/Index.vue")

                },
               /* routes.beforeEach((to, from, next) => {
                    if (this.checkTeacherMenuAccess('online_classroom')) next({ name: 'online-class-room' })
                    else next()
                }),*/
                {
                    path: "classroom/online/add",
                    name: "online-class-rooms-create",
                    meta: {
                        keepAlive: false,
                        title: 'New online classroom',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/online-class-rooms/CreateAndUpdate.vue")

                },
                {
                    path: "classroom/online/update/:room_id",
                    name: "online-class-rooms-update",
                    meta: {
                        keepAlive: false,
                        title: 'Edit online classroom',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/online-class-rooms/CreateAndUpdate.vue")

                },
                {
                    path: "library",
                    name: "library",
                    component: () => import("@/view/pages/library/Base.vue"),
                    children: [
                        {
                            path: "book",
                            name: "library-main",
                            component: () => import("@/view/pages/library/page/Index.vue")
                        },
                        {
                            path: "resources",
                            name: "library-resources",
                            component: () => import("@/view/pages/library/resources/Index.vue")
                        },
                        {
                            path: "resource/:id/attachments",
                            name: "library-resource-attachment-list",
                            component: () => import("@/view/pages/library/page/resource-attachments/Index.vue")
                        }, {
                            path: "resource/:resource/attachment/:attachment/view",
                            name: "library-resource-attachment-view",
                            component: () => import("@/view/pages/library/page/resource-attachments/View.vue")
                        }, {
                            path: "book/:id/detail",
                            name: "book-detail",
                            component: () => import("@/view/pages/library/book/Detail.vue")
                        }, {
                            path: "my-wishlist",
                            name: "my-wishlist",
                            component: () => import("@/view/pages/library/wishlist/Index.vue")
                        },
                        {
                            path: "my-issue",
                            name: "my-issue",
                            component: () => import("@/view/pages/library/issue/Index.vue")
                        },
                    ]
                },
            ]
        },
        {
            path: "/error",
            name: "error",
            component: () => import("@/view/pages/error/Error.vue"),
        },
        {
            path: "/",
            component: () => import("@/view/pages/auth/Auth"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () => import("@/view/pages/auth/Login")
                },
                {
                    name: "verification",
                    path: "/verification",
                    component: () => import("@/view/pages/auth/Verification")
                },
                {
                    name: "forgot-password",
                    path: "/forgot-password",
                    component: () => import("@/view/pages/auth/ForgotPassword")
                },
                {
                    name: "reset-password",
                    path: "/reset-password",
                    component: () => import("@/view/pages/auth/ResetPassword")
                }
            ]
        },
        {
            path: "*",
            redirect: "/404"
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/view/pages/error/Error.vue")
        },

    ]
});
